// initial state
const state = {
  status: true
}

// getters
const getters = {
  status: state => state.status
}

// mutations
const mutations = {
  setStatus (state, data) {
    state.status = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loading.js